import { connect } from 'react-redux'
import * as action from '../../state/detail/action'
import * as selector from '../../state/detail/selector'
import AppointmentDetail from './AppointmentDetail'
import Globals from '../../../globals'


const mapStateToProps = (state, props) => {
    return {
        ...selector.selectOwnState(state),
        appointmentId: props.computedMatch.params.appointmentId,
        salutationList: Globals.selector.selectSalutationList(state),

    }
}

const mapDispatchToProps = {
    findAppointment: action.findAppointment,
    changeAppointment: action.changeAppointment,
    setAppointmentCancelCategory: action.setAppointmentCancelCategory,
}


export default connect(mapStateToProps, mapDispatchToProps)(AppointmentDetail)



// WEBPACK FOOTER //
// ./src/modules/appointment/component/detail/AppointmentDetailContainer.js